export * from './angular.helpers';
export * from './array.helpers';
export * from './class.helpers';
export * from './currency.helpers';
export * from './date.helpers';
export * from './datetime.helpers';
export * from './debounce.helpers';
export * from './dom.helpers';
export * from './error.helpers';
export * from './event.helpers';
export * from './history.helpers';
export * from './http.helpers';
export * from './object.helpers';
export * from './phone.helpers';
export * from './strings.helpers';
export * from './time.helpers';
export * from './url.helpers';
export * from './yesNo.formatter';

/**
 * A function that does nothing.
 * Provided mostly for conveying intent.
 */

export function noOp() {}
export const identityFn = <T>(arg: T) => arg;
